var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['pre-loader', _vm.$activeLang]},[_c('video',{attrs:{"src":require('../../assets/images/loader.mp4'),"id":"loaderVid","autoplay":"true","muted":"muted"},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }